import { infoColor } from './status/info';
export const info = (mode)=>{
    const color = infoColor(mode);
    return {
        main: color.main,
        light: mode === 'light' ? color.lowContrast : color.highContrast,
        dark: mode === 'light' ? color.highContrast : color.lowContrast
    };
};

//# sourceMappingURL=info.js.map